module.exports = __webpack_public_path__ + "img/dot.41822e32.svg";